import React from 'react';
import './ReportLoadingOverlay.scss';

export default function ReportLoadingOverlay({ visible, text = 'Rapor hazırlanıyor...' }) {
  if (!visible) return null;
  return (
    <div className="report-loading-overlay" role="status" aria-live="polite">
      <div className="report-loading-overlay__content">
        <span className="spinner-border" aria-hidden="true" />
        <span>{text}</span>
      </div>
    </div>
  );
}
